import { PRIVACY_URL, TERMS_URL } from '../constants/contact';
import { openExternalUrl } from '../utils/openExternalUrl';

const linkClass =
  'text-[11px] font-medium text-primary underline-offset-2 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 sm:text-xs';

function LegalLink({ href, children }) {
  return (
    <a
      href={href}
      className={linkClass}
      onClick={(e) => {
        e.preventDefault();
        openExternalUrl(href);
      }}
    >
      {children}
    </a>
  );
}

export function LoginTermsNotice({ labels, useMalayalam }) {
  if (useMalayalam) {
    return (
      <p className="text-center text-[11px] leading-snug text-muted sm:text-xs sm:leading-relaxed">
        സൈൻ ഇൻ ചെയ്യുന്നതിലൂടെ നിങ്ങൾ{' '}
        <LegalLink href={TERMS_URL}>{labels.termsLink}</LegalLink> ഒപ്പം{' '}
        <LegalLink href={PRIVACY_URL}>{labels.privacyLink}</LegalLink> അംഗീകരിക്കുന്നു.
      </p>
    );
  }

  return (
    <p className="text-center text-[11px] leading-snug text-muted sm:text-xs sm:leading-relaxed">
      By signing in, you agree to our <LegalLink href={TERMS_URL}>{labels.termsLink}</LegalLink> and{' '}
      <LegalLink href={PRIVACY_URL}>{labels.privacyLink}</LegalLink>.
    </p>
  );
}
